import React from 'react';
import { translate } from '../Services/translation';

const highlightMatch = (text, query) => {
    if (!query || !text) return text;
    const decodedQuery = decodeURIComponent(query);
    const regex = new RegExp(`(${decodedQuery})`, 'igu');
    const parts = text.split(regex);
    return parts.map((part, index) =>
        regex.test(part) ? (
            <span key={index} style={{ fontWeight: 700 }}>
                {part}
            </span>
        ) : (
            <span key={index}>{part}</span>
        )
    );
};

const groupResult = (result) => {
    const groups = {};

    result.forEach((item) => {
        if (groups[item.category]) {
            groups[item.category].items.push(item);
        } else {
            groups[item.category] = { name: item.category, items: [item] };
        }
    });

    return groups;
};

const ResultGroupItem = ({ group, searchUrl, searchString }) => {
    if (!group) return null;

    const renderGroupHeader = () => {
        const firstItem = group.items[0];
        if (firstItem?.showAll === false && firstItem?.category !== 'NoHit') {
            return (
                <h3 className="quick-search-result__group-header">
                    {translate(`quicksearchheader.${group.name.toLowerCase()}`)}
                </h3>
            );
        }
    };

    const renderItem = (item, index) => {
        const linkClass = item.showAll
            ? 'quick-search-result__show-all'
            : `quick-search-result__link ${
                  item.url ? '' : 'quick-search-result__link--disabled'
              }`;
        const linkHref = item.showAll ? searchUrl : item.url;

        return (
            <li
                key={`${item.name}-${index}`}
                className="quick-search-result__item"
            >
                <a className={linkClass} href={linkHref}>
                    <div>
                        <p className="quick-search-result__article-name">
                            {highlightMatch(item.name, searchString)}
                        </p>
                        {item.showAll === false && (
                            <p className="quick-search-result__article-number">
                                {highlightMatch(
                                    item.articleNumber,
                                    searchString
                                )}
                            </p>
                        )}
                    </div>
                </a>
            </li>
        );
    };

    return (
        <div className="quick-search-result__group">
            {renderGroupHeader()}
            <ul>{group.items.map(renderItem)}</ul>
        </div>
    );
};

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
    const resultGroups = groupResult(result);
    const searchString = searchUrl.split('q=')[1];
    const hasAnyResults =
        resultGroups['NoHit'] ||
        resultGroups['ArticleNumberMatch'] ||
        resultGroups['Products'] ||
        resultGroups['Categories'] ||
        resultGroups['Brands'] ||
        resultGroups['Pages'];

    if (hasAnyResults) {
        return (
            <div className="quick-search-result">
                {resultGroups['NoHit'] ? (
                    <div className="quick-search-result__wrapper">
                        <ResultGroupItem
                            group={resultGroups['NoHit']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                            searchString={searchString}
                        />
                    </div>
                ) : (
                    <div className="quick-search-result__wrapper">
                        <ResultGroupItem
                            group={resultGroups['ArticleNumberMatch']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                            searchString={searchString}
                        />
                        <ResultGroupItem
                            group={resultGroups['Products']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                            searchString={searchString}
                        />
                        <ResultGroupItem
                            group={resultGroups['Categories']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                            searchString={searchString}
                        />
                        <ResultGroupItem
                            group={resultGroups['Brands']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                            searchString={searchString}
                        />
                        <ResultGroupItem
                            group={resultGroups['Pages']}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                            searchString={searchString}
                        />
                    </div>
                )}
                {resultGroups['ShowAll'] && (
                    <div className="quick-search-result__show-all">
                        <a
                            href={searchUrl}
                            className="quick-search-result__show-all"
                        >
                            <p>{translate(`quicksearch.showmore`)}</p>
                        </a>
                    </div>
                )}
            </div>
        );
    } else {
        return null;
    }
};

export default QuickSearchResult;
